const siteConfig = {
  name: "Jake Jarvis",
  tagline: "Frontend Web Developer in Boston, MA",
  description:
    "Hi there! I'm a frontend web developer based in Boston, Massachusetts specializing in TypeScript, React, Next.js, and other JavaScript frameworks.",
  license: "CC-BY-4.0",
} as const;

export default siteConfig;
